import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import Action from './table.action';

let table = { ...config };

table.url = '/tms/invoice';
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    width: 150,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.code}
          </div>
          <small className="info">
            {formatDate(row?.schedule_at, 'DD/MM/YYYY') || '-'}
          </small>
        </div>
      );
    },
  },

  customer_id: {
    title: 'Customer',
    sortable: false,
    format_number: false,
    width: 120,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.customer?.name}
          </div>
          <small className="info text-uppercase">
            {row?.customer?.pic_name} - {row?.customer?.pic_phone}
          </small>
        </div>
      );
    },
  },

  billing_to: {
    title: 'Finance',
    sortable: false,
    format_number: false,
    width: 110,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.billing_to}
          </div>
          <small className="info text-uppercase">
            {row?.billing_address}
          </small>
        </div>
      );
    },
  },

  due_date: {
    title: 'Jatuh Tempo',
    sortable: false,
    format_number: false,
    width: 100,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {formatDate(row?.due_date, 'DD/MM/YYYY')}
        </div>
      );
    },
  },

  total_paid: {
    title: 'Total Dibayar',
    format_number: true,
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
  },

  total_charges: {
    title: 'Total Harga',
    format_number: true,
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
  },

  document_status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 100,
    component: (row) => {
      return (
        <span className={`badge status-${row?.document_status}-lt ms-auto `}>
          {row?.document_status?.replace('_', ' ')}
        </span>
      );
    },
  },

  action: {
    title: '',
    sortable: false,
    width: 50,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
